/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const EnrollmentStatus = {
    Pending: 'Pending',
    Enrolled: 'Enrolled',
    Completed: 'Completed',
    Dropped: 'Dropped',
    ScheduledDrop: 'ScheduledDrop',
    Cancelled: 'Cancelled',
    Rejected: 'Rejected',
    Awaiting: 'Awaiting'
} as const;
export type EnrollmentStatus = typeof EnrollmentStatus[keyof typeof EnrollmentStatus];


export function instanceOfEnrollmentStatus(value: any): boolean {
    for (const key in EnrollmentStatus) {
        if (Object.prototype.hasOwnProperty.call(EnrollmentStatus, key)) {
            if (EnrollmentStatus[key as keyof typeof EnrollmentStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function EnrollmentStatusFromJSON(json: any): EnrollmentStatus {
    return EnrollmentStatusFromJSONTyped(json, false);
}

export function EnrollmentStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): EnrollmentStatus {
    return json as EnrollmentStatus;
}

export function EnrollmentStatusToJSON(value?: EnrollmentStatus | null): any {
    return value as any;
}

export function EnrollmentStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): EnrollmentStatus {
    return value as EnrollmentStatus;
}

